import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseEditCreateService } from './base-edit-create.service';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseEditCreateCopyService<T, TEdit> extends BaseEditCreateService<T, TEdit> {
  protected constructor(baseRoute: string, name: string) {
    super(baseRoute, name);
  }

  copy(id: string, key?: string): Observable<string> {
    return this.httpService.get<string>(`${this.apiUrl}/Copy?id=${id}&key=${key}`);
  }
}
